export default __webpack_public_path__ + "static/media/0166.9785e319.jpg";